import styled, { css, keyframes, SimpleInterpolation } from 'styled-components';
import { fadeInLeft } from 'react-animations';

import Media from '../../assets/styles/media';
import THEME from '../../assets/styles/config';

const fadeAnimation = keyframes`${fadeInLeft}`;

export const SvgCtn = styled.div`
  width: 24px;
  margin-right: 22px;

  ${Media.Below.desktop`
    width: 100%;
    margin-right: 0;
  `};

  ${Media.Below.mobileLarge`
    width: 18px;
    margin-right: 7px;
  `}

  > svg {
    stroke: ${THEME.colors.baseIconColor};
    transition: stroke 200ms ease-in-out;
    width: 100%;
    margin-right: 22px;

    ${Media.Below.mobileLarge`
      margin-right: 10px;
    `}
  }
`;

interface TabProps {
  active?: boolean;
  hideOnDesktop?: boolean;
  hideOnMobile?: boolean;
}

export const TabCtn = styled.button<TabProps>`
  display: flex;
  width: 100%;
  padding: 10px 0;
  margin: 10px 0;
  cursor: pointer;
  background-color: transparent;
  border-bottom: transparent 1px solid;
  transition: all 0.5s ease-in-out;

  :focus {
    outline: 0px;
  }

  ${Media.Below.tablet`
    justify-content: center;
    padding: 1vh 0;
    margin: 1vh 0;
  `}

  ${Media.Below.mobileLarge`
    padding: 0;
    margin: 0;
    flex 1 1 auto;
    align-items: center;
    height: 40px;
  `}

  ${(props): SimpleInterpolation =>
    props.hideOnDesktop &&
    css`
      display: none;

      @media screen and (max-width: ${THEME.layout.mobileLarge.breakpoint}px) {
        display: flex;
      }
    `}

  ${(props): SimpleInterpolation =>
    props.hideOnMobile &&
    css`
      @media screen and (max-width: ${THEME.layout.mobileLarge.breakpoint}px) {
        display: none;
      }
    `}

    ${(props): SimpleInterpolation =>
      props.active &&
      css`
        border-bottom: ${THEME.colors.primaryColor} 1px solid;
        }
      `}

  > span {
    ${(props): SimpleInterpolation =>
      props.active &&
      css`
        color: ${THEME.colors.primaryColor};
        transition: max-width 200ms ease-in-out, color 300ms ease-in-out;

        @media screen and (max-width: 480px) {
          animation: 400ms ${fadeAnimation};
          max-width: 90px;
        }
      `}
      
      
  }

  > div {
    > svg {
      ${(props): SimpleInterpolation =>
        props.active &&
        css`
          stroke: ${THEME.colors.primaryColor};
        `}
    }
  }
  
      
    ${(props): SimpleInterpolation =>
  props.sub &&
  css`
      @media only screen and (min-width: 769px) {
        width: 80%;
        align-self:flex-end;
        border-bottom: transparent 1px solid;
      }
    `
} 
`;

export const TabText = styled.span`
  text-align: start;
  font-weight: bold;
  font-size: 14px;
  color: ${THEME.colors.primaryFontColor};

  ${Media.Below.desktop`
    max-width: 0px;
    overflow: hidden;
  `};

  ${Media.Below.mobileLarge`
    font-size: 12px;
    line-height: 12px;
    max-width: 0px;
  `};
`;
